(() => {
  const roots = document.querySelectorAll("[data-korede-soup]");

  const normalize = (value) => String(value || "")
    .replace(/\s+/g, "")
    .replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xfee0))
    .replace(/の/g, "")
    .replace(/スープ/g, "")
    .toLowerCase();

  const sameOption = (actual, expected) => {
    const a = normalize(actual);
    const b = normalize(expected);
    return a === b || a.includes(b) || b.includes(a);
  };

  const formatMoney = (amount) => {
    const value = Number(amount || 0) / 100;
    return new Intl.NumberFormat("ja-JP", {
      style: "currency",
      currency: "JPY",
      maximumFractionDigits: 0
    }).format(value);
  };

  roots.forEach((root) => {
    const dataNode = root.querySelector("[data-korede-variants-json]");
    if (!dataNode) return;

    let variants = [];
    try {
      variants = JSON.parse(dataNode.textContent || "[]");
    } catch (error) {
      variants = [];
    }

    const detailNode = root.querySelector("[data-korede-flavor-details-json]");
    let flavorDetails = {};
    try {
      flavorDetails = JSON.parse(detailNode?.textContent || "{}");
    } catch (error) {
      flavorDetails = {};
    }

    const capacityIndex = Number(root.dataset.capacityIndex || 0);
    const flavorIndex = Number(root.dataset.flavorIndex || 1);
    const form = root.querySelector(".korede-soup__form");
    const variantInput = root.querySelector("[data-korede-variant-id]");
    const addButton = root.querySelector("[data-korede-add-button]");
    const selectedText = root.querySelector("[data-korede-selected-text]");
    const selectedFlavor = root.querySelector("[data-korede-selected-flavor]");
    const selectedComment = root.querySelector("[data-korede-selected-comment]");
    const priceNodes = root.querySelectorAll("[data-korede-price]");
    const sticky = root.querySelector("[data-korede-sticky]");
    const stickyButton = root.querySelector("[data-korede-sticky-button]");
    const stickySummary = root.querySelector("[data-korede-sticky-summary]");
    const optionButtons = root.querySelectorAll("[data-korede-option]");
    const detailButtons = root.querySelectorAll("[data-korede-detail-flavor]");
    const detailLabel = root.querySelector("[data-korede-detail-label]");
    const detailServing = root.querySelector("[data-korede-detail-serving]");
    const ingredientLabel = root.querySelector("[data-korede-ingredients-label]");
    const ingredientText = root.querySelector("[data-korede-ingredients-text]");
    const purchaseArea = root.querySelector("[data-korede-purchase-area]");
    const flavorReviewNodes = root.querySelectorAll("[data-korede-flavor-review]");

    const initialVariant = variants.find((variant) => String(variant.id) === String(variantInput?.value)) || variants[0];
    const state = {
      capacity: initialVariant?.options?.[capacityIndex] || "100g",
      flavor: initialVariant?.options?.[flavorIndex] || "コーン",
      detailFlavor: initialVariant?.options?.[flavorIndex] || "コーン"
    };

    // 味の切替をコレデちゃん（korede-concierge.js）へ通知する。初期表示では発火しない（選び直した時だけ）。
    let announcedFlavor = null;
    const sayFlavor = (flavor, comment) => {
      try {
        document.dispatchEvent(new CustomEvent("korede:flavorchange", {
          detail: { product: "soup", flavor, comment: comment || "" }
        }));
      } catch (error) {}
    };
    const announceFlavor = (comment) => {
      if (announcedFlavor === null) { announcedFlavor = state.flavor; return; }
      if (announcedFlavor === state.flavor) return;
      announcedFlavor = state.flavor;
      sayFlavor(state.flavor, comment);
    };
    // ページ中部の「味の特徴」カードをタップしても同じ吹き出しを出す（Sae 2026-09-21）。選択中の味は変えない。
    const flavorButtonFor = (name) => Array.from(optionButtons).find((button) => {
      return button.dataset.koredeOption === "flavor" && sameOption(button.dataset.value, name);
    });
    root.querySelectorAll(".korede-soup__feature-grid article, .korede-soup__curry-type-grid article").forEach((card) => {
      const name = (card.dataset.koredeFeatureFlavor || card.querySelector("h3, h4")?.textContent || "").trim();
      if (!name) return;
      card.style.cursor = "pointer";
      card.setAttribute("role", "button");
      card.setAttribute("tabindex", "0");
      const fire = () => {
        const button = flavorButtonFor(name);
        sayFlavor(button?.dataset.value || name, button?.dataset.comment || card.querySelector("p")?.textContent || "");
      };
      card.addEventListener("click", fire);
      card.addEventListener("keydown", (event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); fire(); } });
    });

    const getDetail = (flavor) => {
      const key = Object.keys(flavorDetails).find((name) => sameOption(name, flavor));
      return key ? { key, data: flavorDetails[key] } : null;
    };

    const getVariant = () => variants.find((variant) => {
      const capacity = variant.options?.[capacityIndex];
      const flavor = variant.options?.[flavorIndex];
      return sameOption(capacity, state.capacity) && sameOption(flavor, state.flavor);
    });

    const hasAvailableVariant = (type, value) => variants.some((variant) => {
      if (!variant.available) return false;
      if (type === "capacity") {
        return sameOption(variant.options?.[capacityIndex], value);
      }
      const capacity = variant.options?.[capacityIndex];
      const flavor = variant.options?.[flavorIndex];
      return sameOption(capacity, state.capacity) && sameOption(flavor, value);
    });

    const setButtonState = () => {
      optionButtons.forEach((button) => {
        const type = button.dataset.koredeOption;
        const value = button.dataset.value;
        const selected = sameOption(state[type], value);
        const available = hasAvailableVariant(type, value);

        button.classList.toggle("is-selected", selected);
        button.classList.toggle("is-unavailable", !available);
        button.setAttribute("aria-pressed", selected ? "true" : "false");
        button.disabled = !available;
      });

      detailButtons.forEach((button) => {
        const selected = sameOption(state.detailFlavor, button.dataset.koredeDetailFlavor);
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-pressed", selected ? "true" : "false");
      });
    };

    const updateFlavorDetails = () => {
      const detail = getDetail(state.detailFlavor);
      if (!detail?.data) return;

      if (detailLabel) detailLabel.textContent = detail.data.label || detail.key;
      if (detailServing) detailServing.textContent = detail.data.serving || "1食分（粉末20g）あたり";
      if (ingredientLabel) ingredientLabel.textContent = detail.data.label || detail.key;
      if (ingredientText) ingredientText.textContent = detail.data.ingredients || "";

      root.querySelectorAll("[data-korede-nutrition]").forEach((node) => {
        const field = node.dataset.koredeNutrition;
        node.textContent = detail.data[field] || "";
      });
    };

    const update = () => {
      const variant = getVariant() || initialVariant;
      const isAvailable = Boolean(variant?.available);
      const price = formatMoney(variant?.price);
      const summary = `${state.capacity} / ${state.flavor}`;
      state.detailFlavor = state.flavor;

      if (variantInput && variant?.id) variantInput.value = variant.id;
      if (selectedText) selectedText.textContent = `選択中：${summary}`;
      if (selectedFlavor) selectedFlavor.textContent = `選択中：${state.flavor}`;
      const selectedButton = Array.from(optionButtons).find((button) => {
        return button.dataset.koredeOption === "flavor" && sameOption(button.dataset.value, state.flavor);
      });
      if (selectedComment) {
        selectedComment.textContent = selectedButton?.dataset.comment || "";
      }
      announceFlavor(selectedButton?.dataset.comment || "");
      priceNodes.forEach((node) => {
        node.textContent = price;
      });
      if (stickySummary) stickySummary.textContent = `${summary}　${price}`;

      const addButtonText = addButton?.querySelector("span") || addButton;

      if (addButton) {
        addButton.disabled = !isAvailable;
        if (variantInput) variantInput.disabled = !isAvailable;
        if (addButtonText) addButtonText.textContent = isAvailable ? "カートに追加する" : "売り切れ";
      }
      if (stickyButton) {
        stickyButton.disabled = !isAvailable;
      }

      if (variant?.id && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({ path: url.toString() }, "", url.toString());
      }

      setButtonState();
      updateFlavorDetails();
    };

    optionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const type = button.dataset.koredeOption;
        const value = button.dataset.value;
        if (!type || !value || button.disabled) return;
        state[type] = value;
        update();
      });
    });

    detailButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const value = button.dataset.koredeDetailFlavor;
        if (!value) return;
        state.detailFlavor = value;
        setButtonState();
        updateFlavorDetails();
      });
    });

    if (stickyButton && form) {
      stickyButton.addEventListener("click", () => {
        if (addButton?.disabled) return;
        if (form.requestSubmit && addButton) {
          form.requestSubmit(addButton);
          return;
        }
        addButton?.click();
      });
    }

    const updateSticky = () => {
      if (!sticky || !purchaseArea) return;
      const isMobile = window.matchMedia("(max-width: 749px)").matches;
      const rect = purchaseArea.getBoundingClientRect();
      const shouldShow = isMobile && rect.bottom < 0;
      sticky.classList.toggle("is-visible", shouldShow);
      sticky.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    };

    const startFlavorReviewRotation = () => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      flavorReviewNodes.forEach((node, index) => {
        let reviews = [];
        try {
          reviews = JSON.parse(node.dataset.reviews || "[]")
            .map((review) => String(review || "").trim())
            .filter(Boolean);
        } catch (error) {
          reviews = [];
        }

        if (reviews.length < 2) return;

        let reviewIndex = 0;
        const rotate = () => {
          if (document.hidden) return;
          node.classList.add("is-changing");
          window.setTimeout(() => {
            reviewIndex = (reviewIndex + 1) % reviews.length;
            node.textContent = reviews[reviewIndex];
            node.classList.remove("is-changing");
          }, 160);
        };

        window.setTimeout(() => {
          rotate();
          window.setInterval(rotate, 8000);
        }, 8000 + (index * 500));
      });
    };

    window.addEventListener("scroll", updateSticky, { passive: true });
    window.addEventListener("resize", updateSticky);

    update();
    updateSticky();
    startFlavorReviewRotation();
  });

})();
